<!--
  ~  ZAITEC CONFIDENTIAL
  ~  __________________
  ~
  ~ [2019] - [2025] zaiTEC Logixs Ltd
  ~ All Rights Reserved.
  ~
  ~ NOTICE:  All information contained herein is, and remains the property of  zaiTEC Logixs Ltd and its suppliers,if any.
  ~  The intellectual and technical concepts contained herein are proprietary to zaiTEC Logixs Ltd, and are protected by
  ~  trade secret or copyright law.Dissemination of this information or reproduction of this material is strictly forbidden
  ~  unless prior written permission is obtained from  zaiTEC Logixs Ltd.
  -->

<!-- Android/Chrome Prompt -->
<div *ngIf="showInstallPrompt && !isIos" class="install-modal">
  <div class="install-content">
    <h3 data-testid="install-content-h3">Install Dochub Virtual Clinic</h3>
    <button data-testid="install-promot-now-button" (click)="handleInstallClick()">Install Now</button>
    <button data-testid="install-prompt-dismiss-button" class="secondary" (click)="handleDismissClick()">
      Dismiss
    </button>
  </div>
</div>

<!-- iOS Manual Prompt -->
<div *ngIf="showIosInstallGuide" class="install-modal">
  <div class="install-content">
    <h3>Install Dochub Virtual Clinic</h3>
    <p>
      Tap <strong>Share</strong>
      <span class="share-icon-ios" aria-hidden="true">📤</span>
      and then <strong>Add to Home Screen</strong>.
    </p>
    <button
      data-testid="install-prompt-ios-dismiss-button"
      data-testid="ios-dismiss-button"
      class="secondary"
      (click)="handleDismissClick()"
    >
      Dismiss
    </button>
  </div>
</div>
